import Link from "next/link";
import { ChevronDown } from "lucide-react";
import Container from "@/components/ui/container";
import { cn } from "@/lib/cn";

type NavItem = { label: string; href: string; hasDropdown?: boolean };

const items: NavItem[] = [
  { label: "Porcelain", href: "/collections/porcelain", hasDropdown: true },
  { label: "Marble", href: "/collections/marble", hasDropdown: true },
  { label: "Metro", href: "/collections/metro", hasDropdown: true },
  { label: "Mosaic", href: "/collections/mosaic", hasDropdown: true },
  { label: "Outdoor", href: "/collections/outdoor", hasDropdown: true },
  { label: "Terracotta", href: "/collections/terracotta", hasDropdown: true },
  { label: "Large-format", href: "/collections/large-format", hasDropdown: true },
  { label: "Wood-effect", href: "/collections/wood-effect", hasDropdown: true },
];

export default function CategoryTabs() {
  return (
    <nav
      aria-label="Browse by category"
      className="hidden lg:block bg-[color:var(--color-surface-alt)] border-t border-[color:var(--color-border)]"
    >
      <Container>
        <ul className="flex items-center justify-center gap-1 xl:gap-2 h-12 overflow-x-auto">
          {items.map((item) => (
            <li key={item.label} className="shrink-0">
              <Link
                href={item.href}
                className={cn(
                  "inline-flex items-center gap-1 h-12 px-3 xl:px-4 text-sm font-medium transition-colors border-b-2 border-transparent",
                  "text-[color:var(--color-text)] hover:text-[color:var(--color-primary)] hover:border-[color:var(--color-primary)]",
                )}
              >
                {item.label}
                {item.hasDropdown && <ChevronDown size={14} strokeWidth={2} />}
              </Link>
            </li>
          ))}
        </ul>
      </Container>
    </nav>
  );
}
